import { Box, Stack } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const GoalsListViewSkeleton: FC<{ footer?: ReactNode }> = ({ footer }) => {
  return (
    <Page back insetEnabled={false} footer={footer}>
      <Stack alignItems="center" justifyContent="center">
        <ThemedSkeleton variant="text" width="50%" height={18} />
        <ThemedSkeleton variant="text" width="40%" height={18} />
      </Stack>
      <Stack justifyContent="center" flex={1} direction="column" alignItems="center" px={2}>
        <Stack spacing={3} sx={{ width: '100%', mt: 2 }}>
          {[1, 2, 3].map(i => (
            <Stack key={i} direction="column" spacing={1} sx={{ width: '100%', mt: 2 }}>
              <Box display="flex" alignItems="start">
                <Stack flex={1}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                    <Stack direction="row" spacing={1} alignItems="center">
                      <ThemedSkeleton variant="rectangular" width={26} height={26} sx={{ borderRadius: 1 }} />
                      <ThemedSkeleton variant="text" width={120} height={26} />
                    </Stack>
                    <ThemedSkeleton variant="rectangular" width={20} height={20} />
                  </Stack>
                  <Stack spacing={0.5} sx={{ mt: 1 }}>
                    <Stack direction="row" justifyContent="space-between" width="100%">
                      <ThemedSkeleton variant="text" width={60} height={20} />
                      <ThemedSkeleton variant="text" width={80} height={20} />
                    </Stack>
                    <ThemedSkeleton variant="rectangular" width="100%" height={30} sx={{ borderRadius: 1 }} />
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Page>
  );
};
